import { useState, useEffect, useRef } from "react";

interface UseStickyProps {
  isD2C: boolean;
}

const D2C_OFFSET = 100;
const AGENT_OFFSET = 200;

export const useSticky = ({ isD2C }: UseStickyProps) => {
  const [shouldStick, setShouldStick] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const checkStickiness = () => {
    const windowHeight = window.innerHeight;
    const contentHeight = contentRef.current?.offsetHeight || 0;

    setShouldStick(
      contentHeight < windowHeight - (isD2C ? D2C_OFFSET : AGENT_OFFSET)
    );
  };

  useEffect(() => {
    checkStickiness();
    window.addEventListener("resize", checkStickiness);

    const resizeObserver = new ResizeObserver(checkStickiness);
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }

    return () => {
      window.removeEventListener("resize", checkStickiness);
      resizeObserver.disconnect();
    };
  }, [isD2C]);

  return { shouldStick, contentRef };
};
